import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConical, Handshake, ArrowUpRight, CheckCircle2 } from 'lucide-react';

const CommunityCollaboration = ({ isDark, lang }) => {
  const whatsappBase = "https://wa.me/5215660510226?text=";

  const cards = [
    {
      icon: FlaskConical,
      tag: lang === 'es' ? "ACCESO ANTICIPADO" : "EARLY ACCESS",
      title: lang === 'es' ? "Beta Testers & Feedback" : "Beta Testing & Feedback",
      desc: lang === 'es'
        ? "Prueba las versiones previas en Google Play y TestFlight. Ayúdanos a auditar la experiencia de usuario y reportar mejoras antes del despliegue masivo."
        : "Test upcoming builds on Google Play and TestFlight. Help audit interface usability and report improvements before global release.",
      cta: lang === 'es' ? "Solicitar Acceso a Betas" : "Join Beta Program",
      msg: encodeURIComponent(lang === 'es' ? 'Hola, me gustaría participar como Beta Tester en sus aplicaciones.' : 'Hello, I would like to join the beta testing program.'),
      highlights: [
        lang === 'es' ? "Builds cerradas en Google Play / iOS" : "Closed builds on Google Play / iOS",
        lang === 'es' ? "Comunicación directa con desarrollo" : "Direct line to core developers",
        lang === 'es' ? "Influencia real en las funciones" : "Direct impact on feature roadmaps"
      ]
    },
    {
      icon: Handshake,
      tag: lang === 'es' ? "VINCULACIÓN ESTRATÉGICA" : "STRATEGIC ALLIANCE",
      title: lang === 'es' ? "Alianzas Cívicas & Comerciales" : "Civic & Commercial Alliances",
      desc: lang === 'es'
        ? "Buscamos líderes vecinales, locatarios de mercados tradicionales y áreas de selección que busquen integrar herramientas digitales a su entorno."
        : "Partnering with neighborhood leaders, traditional market vendors, and talent recruiters ready to implement digital tools locally.",
      cta: lang === 'es' ? "Iniciar Colaboración" : "Start Partnership",
      msg: encodeURIComponent(lang === 'es' ? 'Hola, me interesa una alianza estratégica o implementar una de sus herramientas.' : 'Hello, I am interested in exploring a partnership or implementing your tools.'),
      highlights: [
        lang === 'es' ? "Implementación piloto sin intermediarios" : "Direct pilot deployment with zero fees",
        lang === 'es' ? "Acompañamiento técnico y operativo" : "Hands-on operational onboarding",
        lang === 'es' ? "Validación y protección comunitaria" : "Community-tested data protection"
      ]
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="text-left mb-12">
          <span className="text-[10px] font-black uppercase tracking-[0.4em] text-blue-500 block mb-2">
            {lang === 'es' ? 'COMUNIDAD ACTIVA' : 'ACTIVE COMMUNITY'}
          </span>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight">
            {lang === 'es' ? 'Colaboración y Testing Abierto' : 'Collaboration & Open Testing'}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {cards.map((card, idx) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={idx}
                whileHover={{ y: -4 }}
                className={`p-8 md:p-10 rounded-[2.5rem] border text-left flex flex-col justify-between transition-all ${
                  isDark
                    ? 'bg-slate-900/30 border-white/10 hover:border-blue-500/30 hover:bg-slate-900/60'
                    : 'bg-white border-slate-200 hover:border-blue-500/30 shadow-sm hover:shadow-xl'
                }`}
              >
                <div>
                  <div className="flex items-center justify-between mb-6">
                    <div className="p-3.5 rounded-2xl bg-blue-500/10 text-blue-400 border border-blue-500/20">
                      <Icon size={24} />
                    </div>
                    <span className="text-[9px] font-black uppercase tracking-wider px-3 py-1 rounded-full bg-blue-500/10 text-blue-400 border border-blue-500/20">
                      {card.tag}
                    </span>
                  </div>

                  <h3 className="text-2xl font-black mb-4">{card.title}</h3>
                  <p className="text-sm font-bold opacity-70 leading-relaxed mb-6">
                    {card.desc}
                  </p>

                  <ul className="space-y-2.5 mb-8">
                    {card.highlights.map((item, hIdx) => (
                      <li key={hIdx} className="flex items-center gap-2.5 text-xs font-bold opacity-75">
                        <CheckCircle2 size={15} className="text-blue-500 shrink-0" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href={`${whatsappBase}${card.msg}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full py-4 rounded-2xl bg-blue-600 hover:bg-blue-500 text-white font-black uppercase text-xs tracking-widest transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-600/20 active:scale-95"
                >
                  <span>{card.cta}</span>
                  <ArrowUpRight size={16} />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CommunityCollaboration;